import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    TextField,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    Collapse,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Select,
    FormControl,
    InputLabel,
    Grid,
    CircularProgress
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import '../../css/table-sort.css';

const themeColor = '#a71e3b';

function GestioneLib() {
    const [isLoading, setIsLoading] = useState(1);
    const [dataLib, setDataLib] = useState([]);
    const [searchLib, setSearchLib] = useState("");
    const [chiave, setChiave] = useState("");
    const [showModalLib, setShowModalLib] = useState(false);
    const [showModalPc, setShowModalPc] = useState(false);
    const [isKeySelected, setIsKeySelected] = useState(false);
    const [libPayload, setLibPayload] = useState({});
    const [libIdLabInventory, setLibIdLabInventory] = useState("");
    const [libName, setLibName] = useState("");
    const [libEdificio, setLibEdificio] = useState("");
    const [libSubnet, setLibSubnet] = useState("");
    const [libIp, setLibIp] = useState("");
    const [libPostazioni, setLibPostazioni] = useState([]);
    const [pcMacAddress, setPcMacAddress] = useState("");
    const [pcIp, setPcIp] = useState("");
    const [pcComputerName, setPcComputerName] = useState("");
    const [reloadData, setReloadData] = useState(false);
    const [expandedRow, setExpandedRow] = useState(null);

    const searchLibHandler = (event) => {
        setSearchLib(event.target.value);
    };

    const handleChiaveChange = (event) => {
        setChiave(event.target.value);
        setIsKeySelected(true);
    };

    const handleCloseModalLib = () => {
        setShowModalLib(false);
    };

    const handleSaveModalLib = () => {
        var formBody = [];
        var tempPayload = libPayload;

        tempPayload.idLabInventory = libIdLabInventory;
        tempPayload.nome = libName;
        tempPayload.edificio = libEdificio;
        tempPayload.subnet = libSubnet;
        tempPayload.ip = libIp;

        setLibPayload(tempPayload);

        setTimeout(async () => {
            setIsLoading(1);

            console.log("save: " + JSON.stringify(libPayload));
            formBody.push("payload=" + JSON.stringify(libPayload));
            await fetch(process.env.REACT_APP_URL_LIBINVENTORY_UPDATE, {
                credentials: 'include',
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            })
                .then((resp) => resp.json())
                .catch((error) => {
                    console.log(error, "Errore!");
                });

            setReloadData(true);
            setShowModalLib(false);
            setIsLoading(0);
        });
    };

    const handleCloseModalPc = () => {
        setShowModalPc(false);
    };

    const handleSaveModalPc = () => {
        var formBody = [];
        var tempPayload = libPayload;

        libPostazioni.forEach(element => {
            if (element.computerName === pcComputerName) {
                element.macAddress = pcMacAddress;
                element.ip = pcIp;
            }
        });

        tempPayload.idLabInventory = libPayload.idLabInventory;
        tempPayload.nome = libName;
        tempPayload.edificio = libEdificio;
        tempPayload.subnet = libSubnet;
        tempPayload.ip = libIp;
        tempPayload.postazioni = libPostazioni;

        setLibPayload(tempPayload);

        setTimeout(async () => {
            setIsLoading(1);

            console.log("save: " + JSON.stringify(libPayload));
            formBody.push("payload=" + JSON.stringify(libPayload));
            await fetch(process.env.REACT_APP_URL_LIBINVENTORY_UPDATE, {
                credentials: 'include',
                method: "POST",
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            })
                .then((resp) => resp.json())
                .catch((error) => {
                    console.log(error, "Errore!");
                });

            setReloadData(true);
            setShowModalPc(false);
            setIsLoading(0);
        });
    };

    useEffect(() => {
        var formBody = [];
        var payload = {
            key: chiave,
            value: searchLib
        };

        function fetchData() {
            setTimeout(async () => {
                setIsLoading(1);

                formBody.push("payload=" + JSON.stringify(payload));
                await fetch(process.env.REACT_APP_URL_LIBINVENTORY_GET, {
                    credentials: 'include',
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: formBody
                })
                    .then((resp) => resp.json())
                    .then((data) => {
                        setDataLib(data);
                    })
                    .catch((error) => {
                        console.log(error, "Errore!");
                    });

                setIsLoading(0);
            });
        }

        setDataLib([]);
        setReloadData(false);
        fetchData();
    }, [searchLib, chiave, reloadData]);

    const handleRowExpand = (row) => {
        const isExpanded = expandedRow === row.idLabInventory;
        setExpandedRow(isExpanded ? null : row.idLabInventory);

        if (!isExpanded) {
            setLibIdLabInventory(row.idLabInventory);
            setLibPostazioni(row.postazioni);
            setLibName(row.nome);
            setLibEdificio(row.edificio);
            setLibSubnet(row.subnet);
            setLibIp(row.ip);
        }
    };

    const handleEditLib = (e, row) => {
        e.stopPropagation();

        var payload = {
            idLabInventory: row.idLabInventory,
            nome: row.nome,
            edificio: row.edificio,
            subnet: row.subnet,
            ip: row.ip,
            postazioni: row.postazioni,
        };

        setLibIdLabInventory(row.idLabInventory);
        setLibName(row.nome);
        setLibEdificio(row.edificio);
        setLibSubnet(row.subnet);
        setLibIp(row.ip);
        setLibPostazioni(row.postazioni);
        setLibPayload(payload);
        setShowModalLib(true);
    };

    const handleEditPc = (e, row, postazione) => {
        e.stopPropagation();

        var payload = {
            idLabInventory: row.idLabInventory,
            nome: row.nome,
            edificio: row.edificio,
            subnet: row.subnet,
            ip: row.ip,
            postazioni: row.postazioni,
        };

        console.log("debug: " + JSON.stringify(payload));
        setPcMacAddress(postazione.macAddress);
        setPcIp(postazione.ip);
        setPcComputerName(postazione.computerName);
        setLibPayload(payload);
        setShowModalPc(true);
    };

    const chiaveOptions = [
        { value: 'nome', label: 'Nome LIB' },
        { value: 'edificio', label: 'Edificio' },
        { value: 'subnet', label: 'Subnet' },
        { value: 'ip', label: 'IP' }
    ];

    const columnsLib = [
        { dataField: "idLabInventory", text: "ID LIB" },
        { dataField: "nome", text: "Nome LIB" },
        { dataField: "edificio", text: "Edificio" },
        { dataField: "subnet", text: "Subnet" },
        { dataField: "ip", text: "IP" },
        { dataField: "abilitato", text: "Abilitato" }
    ];

    const columnsPc = [
        { dataField: "computerName", text: "Computer Name" },
        { dataField: "macAddress", text: "MAC Address" },
        { dataField: "ip", text: "IP" }
    ];

    const LabEditDialog = () => (
        <Dialog
            open={showModalLib}
            onClose={handleCloseModalLib}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 2 }
            }}
        >
            <DialogTitle sx={{
                fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                fontWeight: 700,
                color: themeColor
            }}>
                Modifica Laboratorio
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <TextField
                        label="ID LIB"
                        value={libPayload.idLabInventory || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Nome LIB"
                        defaultValue={libPayload.nome}
                        onChange={(e) => setLibName(e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Edificio"
                        defaultValue={libPayload.edificio}
                        onChange={(e) => setLibEdificio(e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Subnet"
                        defaultValue={libPayload.subnet}
                        onChange={(e) => setLibSubnet(e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="IP Pubblico LIB"
                        defaultValue={libPayload.ip}
                        onChange={(e) => setLibIp(e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button
                    onClick={handleCloseModalLib}
                    variant="outlined"
                    sx={{
                        color: '#666',
                        borderColor: '#ccc',
                        '&:hover': { borderColor: '#999', backgroundColor: '#f5f5f5' }
                    }}
                >
                    Annulla
                </Button>
                <Button
                    onClick={handleSaveModalLib}
                    variant="contained"
                    sx={{
                        backgroundColor: themeColor,
                        '&:hover': { backgroundColor: '#8a1830' }
                    }}
                >
                    Salva
                </Button>
            </DialogActions>
        </Dialog>
    );

    const PcEditDialog = () => (
        <Dialog
            open={showModalPc}
            onClose={handleCloseModalPc}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: 2 }
            }}
        >
            <DialogTitle sx={{
                fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                fontWeight: 700,
                color: themeColor
            }}>
                Modifica Postazione
            </DialogTitle>
            <DialogContent dividers>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                    <TextField
                        label="ID LIB"
                        value={libPayload.idLabInventory || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Nome LIB"
                        value={libPayload.nome || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Edificio"
                        value={libPayload.edificio || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Subnet"
                        value={libPayload.subnet || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="IP pubblico LIB"
                        value={libPayload.ip || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Computer Name"
                        value={pcComputerName || ''}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="Mac Address"
                        defaultValue={pcMacAddress}
                        onChange={(e) => setPcMacAddress(e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                    <TextField
                        label="IP Postazione"
                        defaultValue={pcIp}
                        onChange={(e) => setPcIp(e.target.value)}
                        fullWidth
                        variant="outlined"
                        size="small"
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Button
                    onClick={handleCloseModalPc}
                    variant="outlined"
                    sx={{
                        color: '#666',
                        borderColor: '#ccc',
                        '&:hover': { borderColor: '#999', backgroundColor: '#f5f5f5' }
                    }}
                >
                    Annulla
                </Button>
                <Button
                    onClick={handleSaveModalPc}
                    variant="contained"
                    sx={{
                        backgroundColor: themeColor,
                        '&:hover': { backgroundColor: '#8a1830' }
                    }}
                >
                    Salva
                </Button>
            </DialogActions>
        </Dialog>
    );

    const ExpandableRow = ({ row }) => {
        const isExpanded = expandedRow === row.idLabInventory;

        return (
            <>
                <TableRow
                    hover
                    sx={{
                        cursor: 'pointer',
                        '&:hover': { backgroundColor: '#fafafa' }
                    }}
                    onClick={() => handleRowExpand(row)}
                >
                    <TableCell padding="checkbox">
                        <IconButton size="small">
                            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    {columnsLib.map((column) => (
                        <TableCell key={column.dataField}>
                            {String(row[column.dataField])}
                        </TableCell>
                    ))}
                    <TableCell>
                        <IconButton
                            size="small"
                            onClick={(e) => handleEditLib(e, row)}
                            sx={{ color: themeColor }}
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={columnsLib.length + 2}>
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                            <Box sx={{ margin: 2 }}>
                                <Typography
                                    variant="subtitle1"
                                    sx={{
                                        fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                                        fontWeight: 600,
                                        mb: 2,
                                        color: themeColor
                                    }}
                                >
                                    Postazioni del laboratorio {row.nome}
                                </Typography>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                            {columnsPc.map((column) => (
                                                <TableCell
                                                    key={column.dataField}
                                                    sx={{ fontWeight: 600 }}
                                                >
                                                    {column.text}
                                                </TableCell>
                                            ))}
                                            <TableCell sx={{ fontWeight: 600 }}>Azioni</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {row.postazioni && row.postazioni.map((postazione) => (
                                            <TableRow key={postazione.computerName} hover>
                                                {columnsPc.map((column) => (
                                                    <TableCell key={column.dataField}>
                                                        {String(postazione[column.dataField])}
                                                    </TableCell>
                                                ))}
                                                <TableCell>
                                                    <IconButton
                                                        size="small"
                                                        onClick={(e) => handleEditPc(e, row, postazione)}
                                                        sx={{ color: themeColor }}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        );
    };

    if (!dataLib) {
        return null;
    }

    return (
        <Box>
            <LabEditDialog />
            <PcEditDialog />

            <Typography
                variant="h5"
                sx={{
                    fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                    fontWeight: 400,
                    color: themeColor,
                    mb: 3
                }}
            >
                Inventario LIB (Laboratori fisici)
            </Typography>

            <Paper sx={{ p: 3, mb: 3, borderRadius: 2 }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                        fontWeight: 600,
                        mb: 2
                    }}
                >
                    Ricerca LIB
                </Typography>
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Selezionare chiave</InputLabel>
                            <Select
                                value={chiave}
                                label="Selezionare chiave"
                                onChange={handleChiaveChange}
                            >
                                {chiaveOptions.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        {option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Inserire il valore"
                            value={searchLib}
                            onChange={searchLibHandler}
                            disabled={!isKeySelected}
                        />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                        {isLoading === 1 && (
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <CircularProgress size={30} sx={{ color: themeColor }} />
                            </Box>
                        )}
                    </Grid>
                </Grid>
            </Paper>

            <TableContainer component={Paper} sx={{ borderRadius: 2 }}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                            <TableCell padding="checkbox" />
                            {columnsLib.map((column) => (
                                <TableCell
                                    key={column.dataField}
                                    sx={{
                                        fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                                        fontWeight: 700
                                    }}
                                >
                                    {column.text}
                                </TableCell>
                            ))}
                            <TableCell
                                sx={{
                                    fontFamily: "'PT Sans Narrow', Arial, sans-serif",
                                    fontWeight: 700
                                }}
                            >
                                Azioni
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataLib.map((row) => (
                            <ExpandableRow key={row.idLabInventory} row={row} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default GestioneLib;
